import { useCallback, useState } from 'react';
import { prepareNewTab, navigateNewTab } from '@/lib/newTab';

/**
 * Mở một URL phải chờ mới có (tải blob từ Storage / Drive) ở tab mới, kèm
 * trạng thái `opening` để nút bấm hiện spinner.
 *
 * Vì sao cần: từ khi bỏ signed URL, "mở file" = tải cả file về rồi mới mở.
 * File Drive cũ qua edge function có thể mất vài giây; tab mới hiện trang
 * "Đang tải…" (do prepareNewTab vẽ) còn nút ở app phải báo đang bận, nếu
 * không người dùng tưởng app treo và bấm thêm nhiều lần.
 */
export function useOpenInNewTab() {
  const [opening, setOpening] = useState(false);

  const open = useCallback(
    async (
      resolveUrl: () => Promise<string | null | undefined>,
      onError: (message: string) => void
    ): Promise<boolean> => {
      // Mở tab ĐỒNG BỘ trong sự kiện click, trước mọi await.
      const win = prepareNewTab();
      setOpening(true);
      try {
        const url = await resolveUrl();
        if (!url) {
          win?.close();
          return false;
        }
        navigateNewTab(win, url);
        return true;
      } catch (err) {
        win?.close();
        onError(err instanceof Error ? err.message : String(err));
        return false;
      } finally {
        setOpening(false);
      }
    },
    []
  );

  return { opening, open };
}
